// https://www.npmjs.com/package/axios
import axios from "axios";

const http = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 60000,
});

// ---- 攔截請求
http.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// ---- 攔截回應
// 200 沒事開心
// 400 參數錯誤
// 401 token 失效
// 422 Validation Error
// 500 伺服器錯誤

http.interceptors.response.use(
  (res) => {
    return Promise.resolve(res);
    // 以下藏掉的是參考寫法：
    // https://muki.tw/tech/vue/vue3-vuex-axios-interceptor/
    // switch (res.status) {
    //   case 200:
    //     return Promise.resolve(res)
    //   default:
    //     console.log(res)
    // }
  },
  (e) => {
    console.error("---- API 失敗: ", e);
    // 如果沒有 status，有可能是系統壞去
    if (!e.response.status) {
      return Promise.reject(e);
    }
    switch (e.response.status) {
      case 401:
        console.error(e);
        break;
      case 400:
      case 422:
        console.error(e);
        break;
      case 500:
        console.error(e);
        break;
      default:
        console.error("API 錯誤！", e);
    }
    return Promise.reject(e);
  },
);

export default http;
